// extracted by mini-css-extract-plugin
export default {"address":"style_address__svE+q","address1":"style_address1__ym5o1","address2":"style_address2__4tovr","city":"style_city__upA-m","zip":"style_zip__ULFR8"};